import { useEffect, useRef, type Dispatch, type SetStateAction } from 'react';
import { useSearchParams } from 'react-router-dom';

/**
 * Home tool cards use the existing tutor, never an invented tool route.
 * Call this from the tutor with its input setter to accept a Home tool prompt.
 * This only fills the composer: sending still uses the tutor's normal limits,
 * authentication, conversation history, and OpenAI request handling.
 */
export function useTutorPrefill(
  setInput: Dispatch<SetStateAction<string>>,
  resetConversation?: () => void,
) {
  const [searchParams, setSearchParams] = useSearchParams();
  const setInputRef = useRef(setInput);
  setInputRef.current = setInput;
  const resetRef = useRef(resetConversation);
  resetRef.current = resetConversation;
  const prompt = searchParams.get('prompt');

  useEffect(() => {
    if (!prompt) return;
    resetRef.current?.();
    setInputRef.current(prompt);
    const next = new URLSearchParams(searchParams);
    next.delete('prompt');
    setSearchParams(next, { replace: true });
  }, [prompt, searchParams, setSearchParams]);
}